module.exports = __webpack_public_path__ + "static/media/kishoriMv1.1e82f9c5.png";